<script setup>
import { computed } from 'vue';

// Props Definition
const props = defineProps({
    value: [String, Number],
    item: Object,
});

// Computed Properties
const formattedValue = computed(() => {
    // Currency fields can be set with null values, so only output a
    // formatted value if the value is 0.00 or higher.
    if (props.value !== null && props.value !== undefined) {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            // If the Orders component contains a currency field, override the default.
            currency: props.item.currency || 'gbp'
        }).format(props.value);
    }
    return '';
});

const isDebited = computed(() => {
    return !!props.item.debited;
});
</script>

<template>
    <span v-if="isDebited">({{ formattedValue }})</span>
    <span v-else>{{ formattedValue }}</span>
</template>